import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-base" data-id="element-254" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-255" data-mp="cng1oereb36u">
        <div className="text-center mb-16" data-id="element-256" data-mp="cm52ytct4lml">
          <h2 className="text-4xl md:text-5xl font-display font-extrabold mb-4 text-ink" data-id="element-257" data-mp="7p65q1xujyk6">
            📚 <span className="text-brand" data-id="element-258" data-mp="3g4g8lc9k97t0">150 Ninja classes</span> ready to teach
          </h2>
          <p className="text-xl text-graphite" data-id="element-259" data-mp="3c45zhqqh219x">
            6 complete volumes · 40+ weeks of fresh content · Nothing to build from scratch
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-260" data-mp="3pwvrqcwlg2fh">
          {volumes.map((volume, index) => <motion.div key={volume.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-brand shadow-[0_14px_36px_-22px_rgba(185,62,8,0.55)]' : 'border-silver-light'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-261" data-mp="3l2ho5n7s2ozq" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-35px] bg-brand text-white font-bold text-xs py-1 px-10 rotate-45" data-id="element-262" data-mp="1qgwc5aht26z9">
                  MOST POPULAR
                </div>}
              <div className="flex items-center gap-4 mb-6" data-id="element-263" data-mp="20etzlvrubzqt">
                <span className="text-4xl" aria-hidden="true" data-id="element-264" data-mp="20d95u8dcoku0">
                  {volume.icon}
                </span>
                <div data-id="element-265" data-mp="24eb4oo3cuuvg">
                  <div className="text-brand-dark font-bold text-sm uppercase tracking-wider" data-id="element-266" data-mp="3bu95jp2121y2">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-display font-extrabold leading-tight mt-1 text-ink" data-id="element-267" data-mp="3ftzs1gkitvws">
                    {volume.title}
                  </h3>
                </div>
              </div>
              <p className="text-ink font-medium mb-6 italic border-l-2 border-brand pl-4" data-id="element-268" data-mp="1br7w2fidjhjk">
                {volume.subtitle}
              </p>
              <div className="mb-6" data-id="element-269" data-mp="1ksnx3wnau7b4">
                <h4 className="text-sm font-bold text-graphite-light uppercase tracking-wider mb-2" data-id="element-270" data-mp="1ktplt3x8msbb">
                  What does this solve in your coaching?
                </h4>
                <p className="text-graphite text-sm leading-relaxed" data-id="element-271" data-mp="t21bso1xmhvn">{volume.problem}</p>
              </div>
              <ul className="space-y-3 mb-8 flex-grow" data-id="element-272" data-mp="16sws2lerg199">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-273" data-mp="120vduty180gl">
                    <CheckCircle2 size={18} className="text-brand shrink-0 mt-0.5" aria-hidden="true" data-id="element-274" data-mp="ebu2axtwk973" />
                    <span className="text-graphite text-sm" data-id="element-275" data-mp="2l0upxwbr68ui">{bullet}</span>
                  </li>)}
              </ul>
              <div className="bg-cream border border-silver-light rounded-xl p-4 mt-auto" data-id="element-276" data-mp="2psco6cme5vbs">
                <span className="text-brand-dark font-bold block mb-1" data-id="element-277" data-mp="2c0z8xavinjmk">Result:</span>
                <p className="text-ink text-sm" data-id="element-278" data-mp="2gyhldb8qsgzb">{volume.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}